import { render, staticRenderFns } from "./UserRefundDialog.vue?vue&type=template&id=a265c880&scoped=true"
import script from "./UserRefundDialog.vue?vue&type=script&lang=js"
export * from "./UserRefundDialog.vue?vue&type=script&lang=js"
import style0 from "./UserRefundDialog.vue?vue&type=style&index=0&id=a265c880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a265c880",
  null
  
)

export default component.exports